export default "__VITE_ASSET__a6556e8e__"